"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiSelect = _interopRequireDefault(require("@tencent/spaui-select"));

var _spauiUtils = require("@tencent/spaui-utils");

var _get_data = require("./utils/get_data");

var _column_props = require("./column_props");

var _column_compact_props = _interopRequireDefault(require("./column_compact_props"));

var _number = require("./utils/number");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Column =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Column, _PureComponent);

  function Column(props) {
    var _this;

    _classCallCheck(this, Column);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Column).call(this, props));
    _this.handleSort = _this.handleSort.bind(_assertThisInitialized(_this));
    _this.handleFilter = _this.handleFilter.bind(_assertThisInitialized(_this));
    _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_this));
    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Column, [{
    key: "handleSort",
    value: function handleSort(event, name, order) {
      var _this$props = this.props,
          onSort = _this$props.onSort,
          sortName = _this$props.sortName;
      var sortOrder = ''; // 第一次点击为降序，第二次为升序，第三次取消排序，多次点击依次循环

      if ((0, _spauiUtils.isFunction)(onSort)) {
        if (name === sortName) {
          if (order === 'desc') {
            sortOrder = 'asc';
          } else if (order === 'asc') {
            sortOrder = '';
          } else {
            sortOrder = 'desc';
          }
        } else {
          sortOrder = 'desc';
        }

        onSort(event, name, sortOrder);
      }
    }
  }, {
    key: "handleClear",
    value: function handleClear(event, filterName) {
      var _this$props2 = this.props,
          onFilter = _this$props2.onFilter,
          filterMultiple = _this$props2.filterMultiple;
      var result = '';

      if (filterMultiple) {
        result = [];
      }

      if ((0, _spauiUtils.isFunction)(onFilter)) {
        onFilter(event, filterName, result, filterMultiple);
      }
    } // 筛选回调

  }, {
    key: "handleFilter",
    value: function handleFilter(event, filterName, value) {
      var _this$props3 = this.props,
          onFilter = _this$props3.onFilter,
          filterMultiple = _this$props3.filterMultiple;

      if ((0, _spauiUtils.isFunction)(onFilter)) {
        onFilter(event, filterName, value, filterMultiple);
      }
    }
    /**
     * 获取对应Column筛选整列数据
     * @private
     */

  }, {
    key: "getFilterSelectData",
    value: function getFilterSelectData() {
      var _this$props4 = this.props,
          name = _this$props4.name,
          data = _this$props4.data,
          setFilterLabel = _this$props4.setFilterLabel,
          children = _this$props4.children,
          supportingHierarchicalData = _this$props4.supportingHierarchicalData;
      var result = [],
          uniqueDataMap = {},
          key = ''; // 排重下数据

      data.map(function (item) {
        if (item) {
          uniqueDataMap[(0, _get_data.getValueByName)(item, name, supportingHierarchicalData)] = 1;
        }

        return item;
      }); // 根据排重的数据生成结果数据

      for (key in uniqueDataMap) {
        if (key || typeof key === 'number') {
          result.push({
            value: key,
            label: setFilterLabel(name, key, children)
          });
        }
      }

      return result;
    } // 获取表头单元格的dom内容

  }, {
    key: "getThDom",
    value: function getThDom() {
      var _this2 = this;

      var _compactProps = (0, _column_compact_props["default"])(this.props),
          name = _compactProps.name,
          children = _compactProps.children,
          RenderComponent = _compactProps.RenderComponent,
          SortIconComponent = _compactProps.SortIconComponent,
          alwaysShowSortIcon = _compactProps.alwaysShowSortIcon,
          sortName = _compactProps.sortName,
          sortOrder = _compactProps.sortOrder,
          filterName = _compactProps.filterName,
          filterValue = _compactProps.filterValue,
          FilterComponent = _compactProps.FilterComponent,
          cellInnerClassName = _compactProps.cellInnerClassName,
          setFilterLabel = _compactProps.setFilterLabel,
          _compactProps$filterM = _compactProps.filterMultiple,
          filterMultiple = _compactProps$filterM === void 0 ? false : _compactProps$filterM,
          filterPlaceholder = _compactProps.filterPlaceholder,
          filterSelectOpen = _compactProps.filterSelectOpen,
          onFilterSelectOpen = _compactProps.onFilterSelectOpen,
          sortable = _compactProps.sortable,
          filterable = _compactProps.filterable;

      var result = '',
          sortIcon = '',
          filterData = [],
          newChildren = children,
          selectPlaceholder = filterPlaceholder,
          customLabel = setFilterLabel(name, '', children);

      if (typeof RenderComponent !== 'undefined') {
        result = _react["default"].createElement(RenderComponent, this.props);
      } else {
        if (filterable) {
          filterData = this.getFilterSelectData();

          if (!selectPlaceholder) {
            if ((0, _spauiUtils.isArray)(customLabel)) {
              selectPlaceholder = customLabel[0];
            } else {
              selectPlaceholder = customLabel;
            }
          } // 自己传了筛选组件，就用筛选组件的


          if (typeof FilterComponent !== 'undefined' && (0, _spauiUtils.isFunction)(FilterComponent)) {
            newChildren = _react["default"].createElement(FilterComponent, {
              placeholder: selectPlaceholder,
              multiple: filterMultiple,
              data: filterData,
              value: name === filterName ? filterValue : '',
              onChange: function onChange(event, value) {
                return _this2.handleFilter(event, name, value);
              }
            });
          } else {
            newChildren = _react["default"].createElement(_spauiSelect["default"], {
              open: filterSelectOpen === name,
              onOpen: function onOpen(event, open) {
                return onFilterSelectOpen(event, name, open);
              },
              clearable: true,
              placeholder: selectPlaceholder,
              multiple: filterMultiple,
              searchCheckAll: filterMultiple,
              data: filterData,
              value: name === filterName ? filterValue : filterMultiple ? [] : '',
              onChange: function onChange(event, value) {
                return _this2.handleFilter(event, name, value);
              },
              onClear: function onClear(event) {
                return _this2.handleClear(event, name);
              }
            });
          }
        }

        if (sortable) {
          if (sortName === name) {
            sortIcon = _react["default"].createElement(SortIconComponent, {
              alwaysShowSortIcon: alwaysShowSortIcon,
              name: name,
              sortName: sortName,
              sortOrder: sortOrder
            });
          } else if (alwaysShowSortIcon) {
            // 如果开启了一直展示排序图标，在没有排序的时候也会调用，可以用于展示默认排序标记
            sortIcon = _react["default"].createElement(SortIconComponent, {
              alwaysShowSortIcon: alwaysShowSortIcon,
              name: name,
              sortName: "",
              sortOrder: ""
            });
          }

          result = _react["default"].createElement("a", {
            href: "javascript:;",
            onClick: function onClick(event) {
              return _this2.handleSort(event, name, sortOrder);
            }
          }, children, sortIcon);
        } else {
          result = newChildren;
        }

        result = _react["default"].createElement("div", {
          className: cellInnerClassName
        }, result);
      }

      return result;
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      var onColumnMouseDown = this.props.onColumnMouseDown;

      if (event.target.getAttribute('data-adjustwidth')) {
        if ((0, _spauiUtils.isFunction)(onColumnMouseDown)) {
          onColumnMouseDown(event);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _compactProps2 = (0, _column_compact_props["default"])(this.props),
          align = _compactProps2.align,
          verticalAlign = _compactProps2.verticalAlign,
          show = _compactProps2.show,
          renderable = _compactProps2.renderable,
          colSpan = _compactProps2.colSpan,
          rowSpan = _compactProps2.rowSpan,
          sortName = _compactProps2.sortName,
          sortOrder = _compactProps2.sortOrder,
          name = _compactProps2.name,
          onClick = _compactProps2.onClick,
          adjustWidth = _compactProps2.adjustWidth,
          width = _compactProps2.width,
          _compactProps2$adjust = _compactProps2.adjustMinWidth,
          adjustMinWidth = _compactProps2$adjust === void 0 ? 0 : _compactProps2$adjust,
          _compactProps2$onMous = _compactProps2.onMouseOver,
          onMouseOver = _compactProps2$onMous === void 0 ? _spauiUtils.noop : _compactProps2$onMous,
          _compactProps2$onMous2 = _compactProps2.onMouseOut,
          onMouseOut = _compactProps2$onMous2 === void 0 ? _spauiUtils.noop : _compactProps2$onMous2,
          sortable = _compactProps2.sortable;

      var style = {},
          className = (0, _classnames["default"])({
        'spaui-table-td-sortable': sortable,
        'spaui-table-td-sort': name === sortName,
        'spaui-table-td-sort-asc': name === sortName && sortOrder === 'asc',
        'spaui-table-td-sort-desc': name === sortName && sortOrder === 'desc'
      }),
          thAttributes = {};

      if (align) {
        style.textAlign = align;
      }

      if (verticalAlign) {
        style.verticalAlign = verticalAlign;
      } // 可以指定不渲染


      if (!renderable) {
        return null;
      }

      if (!show) {
        style.display = 'none';
      }

      if (adjustWidth) {
        thAttributes['data-adjustminwidth'] = (0, _number.toInt)(this.props.minWidth) || (0, _number.toInt)(this.props.style && this.props.style.minWidth) || adjustMinWidth;
      }

      return _react["default"].createElement("th", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        style: style,
        className: className
      }), thAttributes, {
        colSpan: colSpan,
        rowSpan: rowSpan,
        onClick: onClick,
        onMouseDown: this.handleMouseDown,
        "data-name": name,
        width: width,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut
      }), this.getThDom(), adjustWidth ? _react["default"].createElement("span", {
        className: "spaui-table-adjust-width-span",
        "data-adjustwidth": "1"
      }) : null);
    }
  }]);

  return Column;
}(_react.PureComponent);

_defineProperty(Column, "propTypes", _column_props.propTypes);

_defineProperty(Column, "defaultProps", _column_props.defaultProps);

var _default = Column;
exports["default"] = _default;